define('views/components/lead_note/lead_note',['require','backbone','text!templates/components/lead_note/lead_note.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/lead_note/lead_note.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'lead-note-item'
    });
});
